import { IconProps } from "../../utils/global-types/global-types";

const SettingsIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-5 h-5"}
      {...rest}
    >
      <g clipPath="url(#clip0_970_63325)">
        <path
          fill="currentColor"
          d="M15.075 7.415c-1.357 0-1.912-.96-1.237-2.137a1.423 1.423 0 0 0-.525-1.943l-1.298-.743a1.25 1.25 0 0 0-1.71.45l-.082.143c-.676 1.177-1.786 1.177-2.468 0l-.082-.143a1.23 1.23 0 0 0-1.695-.45l-1.298.743a1.43 1.43 0 0 0-.525 1.95c.683 1.17.127 2.13-1.23 2.13A1.43 1.43 0 0 0 1.5 8.84v1.32c0 .78.638 1.425 1.425 1.425 1.358 0 1.913.96 1.23 2.137a1.423 1.423 0 0 0 .525 1.943l1.298.742a1.25 1.25 0 0 0 1.71-.45l.082-.142c.675-1.178 1.785-1.178 2.468 0l.082.143a1.25 1.25 0 0 0 1.71.45l1.298-.743c.682-.39.915-1.267.524-1.942-.682-1.178-.127-2.138 1.23-2.138a1.43 1.43 0 0 0 1.425-1.425V8.84a1.44 1.44 0 0 0-1.432-1.425M9 11.938A2.44 2.44 0 0 1 6.563 9.5 2.44 2.44 0 0 1 9 7.063 2.44 2.44 0 0 1 11.438 9.5 2.44 2.44 0 0 1 9 11.938"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_970_63325">
          <path fill="#fff" d="M0 0h18v18H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default SettingsIcon;
